export const ClientLanguageHeader = 'Client-Language';
export const ClientLanguageOverrideHeader = 'Client-Language-Override';
